import { handleMutationError } from '@v2/commons/utils/errorHandling/handleMutationError'
import { WbfPolicies } from '@workers-benefit-fund/shared-data'
import { useEffect } from 'react'

import usePolicyVerification from '../policyVerification/usePolicyVerification'
import { useLazyGetPreSignedUrlQuery } from './formUpload.api'

const useFormAttachmentsUpload = () => {
  const [submitAttachments, { data, isFetching, isError, error }] =
    useLazyGetPreSignedUrlQuery()
  const hasViewAttachmentsPolicyEnabled = usePolicyVerification(
    WbfPolicies.is_get_form_attachment_url_enabled,
  )

  useEffect(() => {
    if (isError) {
      handleMutationError(error, 'failed to upload files!', () => null, 'Close')
    }
  }, [isError])
  return {
    data,
    isFetching,
    submitAttachments,
    hasViewAttachmentsPolicyEnabled,
  }
}

export default useFormAttachmentsUpload
